import { render, staticRenderFns } from "./DeviceAlerts.vue?vue&type=template&id=0abf64e0&scoped=true"
import script from "./DeviceAlerts.vue?vue&type=script&lang=js"
export * from "./DeviceAlerts.vue?vue&type=script&lang=js"
import style0 from "./DeviceAlerts.vue?vue&type=style&index=0&id=0abf64e0&prod&lang=scss"
import style1 from "./DeviceAlerts.vue?vue&type=style&index=1&id=0abf64e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf64e0",
  null
  
)

export default component.exports